<template>
	<div>
		<div class="slide-header">
			<h3>巡檢管理系統</h3>
		</div>
		<el-menu class="el-menu-vertical" :default-active="this.$route.path" @open="handleOpen" @close="handleClose"
			background-color="#304156" :router="true" text-color="#fff">
			<MenuTree :menus="rule"></MenuTree>
		</el-menu>
	</div>
</template>

<script>
	import MenuTree from "@/components/common/MenuTree"
	export default {
		name: "SideBar",
		components:{
			MenuTree
		},
		data() {
			return {
				rule:[]
			}
		},
		created() {
			let _rule = sessionStorage.getItem("rules");
			this.rule = JSON.parse(_rule)
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			}
		}
	}
</script>

<style scoped>
	.el-menu-vertical{
		width: 100%;
		height:calc(100vh - 60px);
	}

	.slide-header{
		width: 100%;
		height:60px;
		overflow: hidden;
		background-color: #304156;
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
	}

	.slide-header h3{
		font-size: 16px;
		letter-spacing: 1px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/SideBar.vue